import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopNews from '../../common/header/HeaderTopNews';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import { FiArrowRight } from 'react-icons/fi';
import SectionTitle from '../../elements/sectionTitle/SectionTitle';
import SpeakingCategories from '../../components/speaking/SpeakingCategories';
import SpeakingSpeaker from '../../components/speaking/SpeakingSpeaker';
import Separator from '../../elements/separator/Separator';
import SpeakingCallToAction from '../../components/speaking/SpeakingCallToAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import TestimonialThree from './../../elements/testimonial/TestimonialThree';
import VideoOne from './../../elements/video/VideoOne';
import SpeakingMenu from '../../components/training/TrainingMenu';
import SpeakingTestimonial from '../../components/speaking/SpeakingTestimonial';
import SpeakingVideo from '../../components/speaking/SpeakingVideo';
import SpeakerAbout from './../../components/speaking/SpeakerAbout';
import SpeakerTopics from './../../components/speaking/SpeakerTopics';
import MainTestimonial from '../../elements/testimonial/MainTestimonial';
import TrainingCategories from '../../components/training/TrainingCategories';
import SpeakerTopicsTwo from '../../components/speaking/SpeakerTopicsTwo';
import SpeakerPricing from '../../components/speaking/SpeakerPricing';
import SpeakerUpdatePricing from '../../components/speaking/SpeakerUpdatePricing';
import SpeakingForm from '../../components/speaking/SpeakingForm';

const Speaking = () => {
    
    return (
        <>
            <SEO title="Book Speaker" />
            <main className="page-wrapper">
                {/* <HeaderTopNews /> */}
                <HeaderOne  btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" data-black-overlay="7" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/training/hero.jpg)`}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    <h1 className="title display-one">Book Jahid Hasan — A Speaker Who Sparks Action</h1>
                                    <p className="description">No two events are the same. Find the perfect speaker for your next event.
                                    </p>
                                    <div>
                                    
                                    <div className="button-group">
                                        <a className="btn-default btn-medium round btn-icon" href="#bookingform">Book Now <i className="icon"><FiArrowRight /></i></a>
                                        {/* <Link className="btn-default btn-medium btn-border round btn-icon" to="#">Contact Us <i className="icon"><FiArrowRight /></i></Link> */}
                                    </div>
                                    <img style={{height: "100px", marginTop:"10px"}} src={`${process.env.PUBLIC_URL}/images/training/down-arrow.avif`} alt="Corporate Logo" />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}


                {/* Start Speaker Info*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    // subtitle = "Consulting Services"
                                    title = "Speaker"
                                    description = ""
                                />
                            </div>
                        </div>
                        <SpeakingSpeaker/>
                    </div>
                </div>
                {/* End Speaker Info  */}

                {/* Start Speaker Menu*/}
                <div className="rwt-callto-action-area">
                    <div className="wrapper">
                        <SpeakingMenu />
                    </div>
                </div>
                {/* End Speaker Menu  */}
                {/* Start Speaker About*/}
                <div className="rwt-advance-tab-area rn-section-gap" id='about'>
                    <div className="container">
                        <SpeakerAbout/>
                    </div>
                </div>
                {/* End Speaker About  */}

                {/* Start Elements Area  */}
                <div className="rwt-video-popup-area rn-section-gap" id='videos'>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                        {/* <SectionTitle
                                            textAlign = "text-center"
                                            radiusRounded = ""
                                            // subtitle = "Popup Video"
                                            title = "Videos"
                                            description = ""
                                        /> */}
                                        <h4 className='text-left'>Videos</h4>
                                </div>
                            </div>
                            <SpeakingVideo />
                        </div>
                    </div>
                    {/* End Elements Area  */}

                    <div className="rwt-advance-tab-area rn-section-gap" id='topics'>
                    <div className="container mt-5 mb-5">
                        <h4 className='text-left'>Topics</h4>
                        <SpeakerTopics/>
                    </div>

                    <div className="container mb-5 mt-5">
                        <SpeakerTopicsTwo/>
                    </div>

                    <div className="container mt-5">
                        <h3 className='text-left mt-5 pt-5'>Speaker Pricing:</h3>
                        <SpeakerUpdatePricing/>
                    </div>
                    <div className="container mt-5 rn-section-gap" id='bookingform'>
                        {/* <h3 className='text-left mt-5 pt-5'>Speaker Pricing:</h3> */}
                        <SpeakingForm/>
                    </div>

                </div>
                {/* End Speaker About  */}

                {/* Start Elements Area Testimonmial */}
                <div className="rwt-elements-area rn-section-gap" id='testimonial'>
                        <div className="container">
                            <div className="row mb--20">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle="Client Feedback"
                                    title="Our Awesome Client."
                                    description="We Provide The Best Training & Consulting Services to Improve Your Life, Business & Income."
                                    />
                                </div>
                            </div>
                            <MainTestimonial teamStyle="" />
                        </div>
                    </div>
                {/* End Elements Area  */}



                {/* Start Categories Area  */}
                <div className="rwt-brand-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    // subtitle = "Our Awesome Client"
                                    title = "Featured Category"
                                    description = ""
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 mt--10">
                                <TrainingCategories brandStyle="brand-style-2" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Categories Area  */}

                {/* Start Elements Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <SpeakingCallToAction />
                    </div>
                </div>
                {/* End Elements Area  */}



                <FooterOne />
                <Copyright />                    

            </main>
            
        </>
    )
}
export default Speaking

